module.exports = __webpack_public_path__ + "img/1.e3972c06.jpg";